module.exports = __webpack_public_path__ + "img/product_icon_ai.15dff3ef.png";